import React, { useState } from "react";
import "./FilterModal.css";

export default function FilterModal({
  isOpen,
  onClose,
  onApply,
  filters,
  allBranches,
  allDivisions,
}) {
  const [autonomy, setAutonomy] = useState(filters.autonomy);
  const [branches, setBranches] = useState(filters.branches);
  const [divisions, setDivisions] = useState(filters.divisions);

  if (!isOpen) return null;

  const toggleSelection = (list, setList, value) => {
    setList((prev) =>
      prev.includes(value) ? prev.filter((v) => v !== value) : [...prev, value]
    );
  };

  return (
    <div className="filter-modal-overlay">
      <div className="filter-modal-content">
        <h2>Filter Colleges</h2>

        {/* Autonomy Filter */}
        <div className="filter-section">
          <h3>Autonomy</h3>
          <div className="options">
            {["All", "Autonomous", "Non-Autonomous"].map((opt) => (
              <button
                key={opt}
                className={autonomy === opt ? "selected" : ""}
                onClick={() => setAutonomy(opt)}
              >
                {opt}
              </button>
            ))}
          </div>
        </div>

        {/* Branch Filter */}
        <div className="filter-section">
          <h3>Branches</h3>
          <div className="options">
            {allBranches.map((b) => (
              <button
                key={b}
                className={branches.includes(b) ? "selected" : ""}
                onClick={() => toggleSelection(branches, setBranches, b)}
              >
                {b}
              </button>
            ))}
          </div>
        </div>

        {/* Division Filter */}
        <div className="filter-section">
          <h3>Divisions</h3>
          <div className="options">
            {allDivisions.map((d) => (
              <button
                key={d}
                className={divisions.includes(d) ? "selected" : ""}
                onClick={() => toggleSelection(divisions, setDivisions, d)}
              >
                {d}
              </button>
            ))}
          </div>
        </div>

        {/* Actions */}
        <div className="filter-actions">
          <button className="cancel-btn" onClick={onClose}>
            Cancel
          </button>
          <button
            className="apply-btn"
            onClick={() => {
              onApply({ autonomy, branches, divisions });
              onClose();
            }}
          >
            Apply
          </button>
        </div>
      </div>
    </div>
  );
}
    